import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ChangeHistoryComponent } from '../change-history.component';

type ChangeHistoryTables =
	| 'Account'
	| 'AR_Invoice'
	| 'HCM_Position'
	| 'HCM_StaffActionTemplate'
	| 'Invoice'
	| 'PR_Deduction'
	| 'PR_Employee'
	| 'PR_EmployeeHours'
	| 'PurchaseOrder'
	| 'Vendor';

@Component({
    selector: 'sl-change-history-button',
    templateUrl: './change-history-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatButtonModule,
        MatIconModule,
        NgIf,
    ],
})
export class ChangeHistoryButtonComponent {
	@Input() entity: ChangeHistoryTables;
	@Input() id: number;
	@Input() hideButtonText = true;
	@Input() buttonTitle = 'View Change History';

	constructor(private readonly dialog: MatDialog) {}

	toggleModal(): void {
		this.dialog.open(ChangeHistoryComponent, {
			minWidth: '70vw',
			data: {
				entity: this.entity,
				id: this.id,
			},
		});
	}
}
